import AdminDatePicker from "routes/admin/datePicker/AdminDatePicker";
import style from "./PromotionInquirySearch.module.css";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import Center from "layouts/wrapper/Center";
import P from "components/P";
import CustomButton from "components/buttons/CustomButton";
import { forwardRef, useContext, useEffect, useRef, useState } from "react";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useTranslation } from "react-i18next";
import InputText from "components/inputs/InputText";
import { Radio, RadioGroup } from "@mui/material";
import { useNavigate } from "react-router-dom";

const PromotionInquirySearch = forwardRef((props, ref) => {
  const { t } = useTranslation();
  const [reload, setReload] = useState(false);
  const inputRef = useRef();
  // newDay.setDate(today.getDate() - 7);

  const [isMounted, setIsmounted] = useState(false);
  const [selectedPromotionStatus, setSelectedPromotionStatus] = useState("all");
  const [selectedPromotionType, setSelectedPromotionType] = useState(
    "discount"
  );
  const onPromotionTypeChange = (e) => {
    setSelectedPromotionType(e.target.value);
  };
  const onPromotionStatusValueChange = (e) => {
    setSelectedPromotionStatus(e.target.value);
  };

  useEffect(() => {
    setIsmounted(true);
  }, []);
  useEffect(() => {
    if (isMounted) {
      inputRef.current.focus();
      onInitializationClick();
    }
  }, [isMounted]);
  useEffect(() => {
    if (reload) {
      setReload(false);
      onSearchClick();
    }
  }, [reload]);
  // const datePickerClick = (active) => {
  //     setActive(active);
  // }

  //   const onCategorySearchClick = () => {
  //     NiceModal.show("checkSelect", {
  //       list: categories,
  //       title: "카테고리 목록",
  //       theader: categorySelectHeader,
  //       justifyContent: "flex-start",
  //       onSelect: onCategorySelect,
  //     });
  //   };
  //   const onCategorySelect = (categories) => {

  //     setSelectedCategories(categories);
  //   };

  const onSearchClick = () => {
    if (props.callback) {
      props.callback({
        input: inputRef.current.getValue(),
        type: selectedPromotionType,
        pr_status: selectedPromotionStatus,
      });
    }
  };

  const onInitializationClick = () => {
    inputRef.current.setValue("");
    setSelectedPromotionType("discount");
    setSelectedPromotionStatus("all");
    setReload(true);
  };

  const searchStyle = {
    backgroundColor: "var(--admin-main-color)",
    padding: "7px 20px",
    border: "1px solid #ddd",
  };
  const initializationStyle = {
    backgroundColor: "white",
    padding: "7px 20px",
    color: "black",
    border: "1px solid #ddd",
  };

  return (
    <div className={style.container}>
      <VerticalFlex>
        <FlexChild>
          <VerticalFlex>
            <FlexChild>
              <HorizontalFlex gap={10} justifyContent={"flex-start"}>
                <FlexChild
                  width={"10%"}
                  backgroundColor={"var(--admin-table-bg-color)"}
                >
                  <div className={style.titleWrap}>
                    <Center>
                      <P size={15} weight={"bold"}>
                        이름
                      </P>
                    </Center>
                  </div>
                </FlexChild>
                <FlexChild width={300}>
                  {/* <HorizontalFlex gap={10} justifyContent={"flex-start"}> */}
                  <InputText
                    ref={inputRef}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") onSearchClick();
                    }}
                  />
                  {/* </HorizontalFlex> */}
                </FlexChild>
              </HorizontalFlex>
            </FlexChild>
            <FlexChild>
              <HorizontalFlex gap={10}>
                <FlexChild
                  width={"10%"}
                  backgroundColor={"var(--admin-table-bg-color)"}
                >
                  <div className={style.titleWrap}>
                    <Center>
                      <P size={15} weight={"bold"}>
                        상품구분
                      </P>
                    </Center>
                  </div>
                </FlexChild>
                <FlexChild>
                  <RadioGroup
                    value={selectedPromotionType}
                    onChange={onPromotionTypeChange}
                  >
                    <HorizontalFlex gap={10} justifyContent={"flex-start"}>
                      {/* <FlexChild width={"max-content"}>
                        <Radio name="productType" value="all" />
                        <P size={15} color={"#aaa"}>
                          전체
                        </P>
                      </FlexChild> */}
                      <FlexChild width={"max-content"}>
                        <Radio name="productType" value="discount" />
                        <P size={15} color={"#aaa"}>
                          할인
                        </P>
                      </FlexChild>
                      <FlexChild width={"max-content"}>
                        <Radio name="productType" value="event" />
                        <P size={15} color={"#aaa"}>
                          증정
                        </P>
                      </FlexChild>
                    </HorizontalFlex>
                  </RadioGroup>
                </FlexChild>
              </HorizontalFlex>
            </FlexChild>
            <FlexChild>
              <HorizontalFlex>
                <FlexChild
                  width={"10%"}
                  backgroundColor={"var(--admin-table-bg-color)"}
                >
                  <div className={style.titleWrap}>
                    <Center>
                      <P size={15} weight={"bold"}>
                        상태
                      </P>
                    </Center>
                  </div>
                </FlexChild>
                <FlexChild>
                  <RadioGroup
                    value={selectedPromotionStatus}
                    onChange={onPromotionStatusValueChange}
                  >
                    <HorizontalFlex gap={30}>
                      <FlexChild width={"max-content"}>
                        <Radio name="restockStatus" value="all" />
                        <P size={15} color={"#aaa"}>
                          전체
                        </P>
                      </FlexChild>
                      <FlexChild width={"max-content"}>
                        <Radio name="restockStatus" value="continue" />
                        <P size={15} color={"#aaa"}>
                          진행중
                        </P>
                      </FlexChild>
                      <FlexChild width={"max-content"}>
                        <Radio name="restockStatus" value="ready" />
                        <P size={15} color={"#aaa"}>
                          예정
                        </P>
                      </FlexChild>
                      <FlexChild>
                        <Radio name="restockStatus" value="end" />
                        <P size={15} color={"#aaa"}>
                          종료
                        </P>
                      </FlexChild>
                    </HorizontalFlex>
                  </RadioGroup>
                </FlexChild>
              </HorizontalFlex>
            </FlexChild>
          </VerticalFlex>
        </FlexChild>
        <FlexChild backgroundColor={"#f5f6fb"} padding={"15px 0"}>
          <HorizontalFlex gap={20}>
            <FlexChild justifyContent={"flex-end"}>
              <CustomButton
                text={"조건검색"}
                style={searchStyle}
                onClick={onSearchClick}
              />
            </FlexChild>
            <FlexChild>
              <CustomButton
                text={"초기화"}
                style={initializationStyle}
                onClick={onInitializationClick}
              />
            </FlexChild>
          </HorizontalFlex>
        </FlexChild>
      </VerticalFlex>
    </div>
  );
});

export default PromotionInquirySearch;
